import { yupResolver } from "@hookform/resolvers/yup";
import Form from "components/forms/form";
import TextInput from "components/forms/inputs/text";
import FormButtons from "components/forms/buttons";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { FormValues } from "lib/form";
import { SubmitButton } from "components/forms/buttons.utils";
import { useTranslate } from "stores/hooks/translation";

export interface FormModel {
  email: string;
  password: string;
}

interface LoginFormProps {
  onSubmit: (values: FormValues) => Promise<void>;
}

const LoginForm: FunctionComponent<LoginFormProps> = ({ onSubmit }) => {
  const translate = useTranslate();

  const schema = yup.object({
    email: yup.string().validateEmail().validateRequired(),
    password: yup.string().validateRequired(),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: import.meta.env.VITE_PUBLIC_DEFAULT_EMAIL || "",
      password: import.meta.env.VITE_PUBLIC_DEFAULT_PASSWORD || "",
    },
  });

  return (
    <Form methods={methods} onSubmit={onSubmit} dataFormType="login">
      <Grid>
        <Row>
          <Col>
            <TextInput
              name="email"
              label={translate("login_label_email")}
              placeholder={translate("login_label_email")}
              required
              autoComplete="username"
              maxLength={128}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInput
              password
              name="password"
              label={translate("login_label_password")}
              placeholder={translate("login_label_password")}
              required
              autoComplete="current-password"
              maxLength={128}
            />
          </Col>
        </Row>
        <FormButtons
          buttons={[{ ...SubmitButton, text: translate("login_button") }]}
        />
      </Grid>
    </Form>
  );
};

export default LoginForm;
